export default {
  confirm: '確認',
  cancel: 'やめる'
};
